export const PARTNER_STORE_CARD_CLICKED = 'Partner Store Card Clicked'
export const PARTNER_STORE_CARD_VIEWED = 'Partner Store Card Viewed'
